// Turn any thrown value (axios error, Error, string) into a message that is safe to show the user.
// Server messages win; otherwise we explain network/timeout/HTTP problems in plain words.
export const isCanceled = (err) =>
  err?.name === "CanceledError" || err?.code === "ERR_CANCELED";

export const getErrorMessage = (err, fallback = "Something went wrong. Please try again.") => {
  if (!err) return fallback;
  if (typeof err === "string") return err;

  const data = err.response?.data;
  const serverMsg =
    (typeof data === "string" && data.length < 200 && data) ||
    data?.error ||
    data?.message ||
    data?.msg;
  if (typeof serverMsg === "string" && serverMsg.trim()) return serverMsg;

  if (err.code === "ECONNABORTED" || err.code === "ETIMEDOUT") {
    return "The server took too long to respond. Please try again.";
  }
  if (err.request && !err.response) {
    return typeof navigator !== "undefined" && navigator.onLine === false
      ? "You appear to be offline. Check your connection and try again."
      : "Unable to reach the server. Please try again.";
  }

  const status = err.response?.status;
  if (status === 403) return "You don't have permission to do that.";
  if (status === 404) return fallback;
  if (status >= 500) return "Server error. Please try again in a moment.";

  return fallback;
};
